import { ImageProps } from "./image-props";

export const ProjectTeamRocket24Image = (props: ImageProps) => {
    return (
        <img
            height={24}
            width={24}
            alt={props.alt}
            src="https://wac-cdn.atlassian.com/misc-assets/webp-images/rocket-icon.webp"
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
